var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('legend',{staticClass:"legend-title"},[_vm._v(" Request Settings ")]),_c('ProgrammaticTargetRequestSettings',{attrs:{"programmatic-target":_vm.programmaticTarget,"readonly":""},on:{"update":_vm.updateTargetDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }